import {
  GET_ALL_PROJECTS,
  SET_LOADING,
  IS_INCLUDE_ARCHIVED,
  IS_MY_PROJECTS,
  SET_PROJECT_DATA,
  SET_PROJECT_DETAILS,
  SET_PROJECT_DETAILS_LOADING,
  SET_TAB_CONTENT,
  SET_PROJECT_SEARCH_TEXT,
  SET_PROJECT_LOADING,
  SET_CUSTOM_COLUMNS_LIST,
  SET_PROJECT_SEARCH_TYPE,
  SET_REPURPOSE_PACKAGING_ASSETS_LOADING,
  SET_WORKFLOW_ITEMS,
  RESET_PROJECT_DATA,
  RESET_PROJECT_METRIC_DATA,
  SET_PROJECT_METRIC_DATA,
} from './actionTypes'

const dashboardResultState = {
  projects: [],
  loading: false,
  isMyProjects: false,
  searchQuery: '',
  isIncludedArchived: false,
  projectDataReducer: {},
  projectDetails: {},
  projectDetailsLoading: false,
  photobridgeData: {},
  projectMetricReducer: {},
  projectTcinInfoReducer: [],
  projectLoading: false,
  repurposeLoading: false,
  customColumnsList: [],
  total_count: 10,
  total_pages: 1,
}
export default function dashboardReducer(state = dashboardResultState, action) {
  switch (action.type) {
    case SET_TAB_CONTENT:
      return { ...state, projectTcinInfoReducer: action.payload }
    case SET_PROJECT_DATA: {
      return {
        ...state,
        projectDataReducer: Object.assign(
          {},
          { ...state?.projectDataReducer },
          { ...action?.payload }
        ),
      }
    }
    case SET_PROJECT_METRIC_DATA:
      return {
        ...state,
        projectMetricReducer: Object.assign(
          {},
          { ...state?.projectMetricReducer },
          { ...action?.payload }
        ),
      }
    case SET_PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: Object.assign(
          {},
          { ...state?.projectDetails },
          { ...action?.payload }
        ),
      }
    case SET_PROJECT_DETAILS_LOADING:
      return {
        ...state,
        projectDetailsLoading: action.payload,
      }
    case SET_WORKFLOW_ITEMS:
      return {
        ...state,
        photobridgeData: Object.assign(
          {},
          { ...state?.photobridgeData },
          {
            [action?.payload?.projectId]: action?.payload?.data || {},
          }
        ),
      }
    case RESET_PROJECT_DATA:
      return {
        ...state,
        projectDataReducer: {},
      }
    case RESET_PROJECT_METRIC_DATA:
      return {
        ...state,
        projectMetricReducer: {},
        photobridgeData: {},
      }
    case SET_PROJECT_SEARCH_TYPE:
      return {
        ...state,
        searchType: action.payload,
      }
    case SET_PROJECT_LOADING:
      return {
        ...state,
        projectLoading: action.payload,
      }
    case SET_REPURPOSE_PACKAGING_ASSETS_LOADING:
      return {
        ...state,
        repurposeLoading: action.payload,
      }
    case SET_CUSTOM_COLUMNS_LIST:
      return {
        ...state,
        customColumnsList: action.payload,
      }
    case GET_ALL_PROJECTS:
      return {
        ...state,
        projects: [...action.payload.data],
        total_count: action.payload.total_count,
        total_pages: action.payload.total_pages,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SET_PROJECT_SEARCH_TEXT:
      return {
        ...state,
        searchQuery: action.payload,
      }
    case IS_MY_PROJECTS:
      return {
        ...state,
        isMyProjects: action.payload,
      }
    case IS_INCLUDE_ARCHIVED:
      return {
        ...state,
        isIncludedArchived: action.payload,
      }
    default:
      return state
  }
}
